import { Box, TextField, Typography } from '@mui/material';

const PARTS_COUNT = 4;

const VersionInput = ({ value = [], onChange, ...props }) => {
  const version = [...Array(PARTS_COUNT)].map((_, index) => value[index] ?? '');

  const handleChange = (index, newValue) => {
    const nextVersion = [...version];

    nextVersion[index] = newValue.replace(/\D/g, '');

    onChange?.(nextVersion);
  };

  return (
    <Box
      dir="ltr"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        direction: 'ltr',
      }}
    >
      {version.map((part, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
          <TextField
            value={part}
            onChange={e => handleChange(index, e.target.value)}
            inputProps={{
              maxLength: 3,
              inputMode: 'numeric',
              dir: 'ltr',
              style: { textAlign: 'center' },
            }}
            sx={{
              width: 60,
              direction: 'ltr',
            }}
            {...props}
          />
          {index < PARTS_COUNT - 1 && <Typography sx={{ mx: 1 }}>.</Typography>}
        </Box>
      ))}
    </Box>
  );
};

export default VersionInput;
